import type { Router } from "@/typeDefinitions/custom/Router";
import { chartLayoutCategories } from "./chartTypes";
import ChartLayoutOptions from "./ChartLayoutOptions";

const router: Router.LicensedRouterExportType = [
  {
    path: "/chartLayoutOverview",
    name: "chartLayoutOverview",
    component: () => import("./views/ChartLayoutOverview.vue"),
    meta: {
      rights: ["sqdc.admin"],
    },
  },
  {
    path: "/chartLayout/create/:id",
    name: "createChartLayout",
    component: () => import("./views/CreateChartLayout.vue"),
    meta: {
      rights: ["sqdc.admin"],
    },
    props: (route) => {
      let type: keyof typeof ChartLayoutOptions;

      if (typeof route.params.id === "string") {
        if (route.params.id in chartLayoutCategories && route.params.id in ChartLayoutOptions) {
          type = route.params.id as keyof typeof ChartLayoutOptions;
        } else {
          throw Error("Invalid chart type");
        }
      } else {
        throw Error("loading not implemented");
      }

      return {
        type,
        default: route.query.default,
      };
    },
  },
  {
    path: "/chartLayout/detail/:type/:id",
    name: "updateChartLayout",
    component: () => import("./views/UpdateChartLayout.vue"),
    meta: {
      rights: ["sqdc.admin"],
    },
    props: (route) => ({
      chartLayoutId: Number(route.params.id),
      type: route.params.type,
    }),
  },
  {
    path: "/target",
    name: "target",
    component: () => import("./views/TargetList.vue"),
    meta: {
      rights: ["sqdc.admin"],
    },
  },
  {
    path: "/target/create",
    name: "targetCreate",
    component: () => import("./views/TargetEditor.vue"),
    meta: {
      rights: ["sqdc.admin"],
    },
    props: (route) => ({
      mode: "create",
      siteId: route.query.siteId == null ? undefined : Number(route.query.siteId),
      costCenterId: route.query.costCenterId == null ? undefined : Number(route.query.costCenterId),
      datapointTypeId:
        route.query.datapointTypeId == null ? undefined : Number(route.query.datapointTypeId),
      granularity: route.query.granularity,
    }),
  },
  {
    path: "/target/:costCenterId/:datapointTypeId",
    name: "targetDetail",
    component: () => import("./views/TargetEditor.vue"),
    meta: {
      rights: ["sqdc.admin"],
    },
    props: (route) => ({
      mode: "detail",
      costCenterId: Number(route.params.costCenterId),
      datapointTypeId: Number(route.params.datapointTypeId),
    }),
  },
];

export default router;
